// extracted by mini-css-extract-plugin
export var seperator = "index-module--seperator--1a1dd";
export var text_wrapper = "index-module--text_wrapper--29abc";
export var vision_container = "index-module--vision_container--c70c6";